import { Action } from '@ngrx/store';

export enum UsuarioActionTypes {
  USER_NEW = '[USER_NEW] Add usuario',
  USER_ALL = '[USER_NEW] Get ALL',
}

export class UsuarioAll implements Action {
  readonly type = UsuarioActionTypes.USER_ALL;
}

export class UsuarioNovo implements Action {
  readonly type = UsuarioActionTypes.USER_NEW;
  constructor(public payload: { user: object }) {}
}

export type UsuarioActions = UsuarioNovo | UsuarioAll;
